<template>
    <div class="report-box">
        <VideoShow ref="VideoShow"  />

        <div class="report-title">
            {{base_data.work_name}} --答题报告
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="答题卡" name="first">
                <template>
                    <div class="view-report-all-btn">
                        <el-button size="small" type="success" @click="viewReportAll" round>全部详情</el-button>
                    </div>
                    <el-table :data="question_map" stripe style="width: 100%">
                        <el-table-column
                        type="index"
                        width="50"
                        abel="序号">
                        </el-table-column>

                        <el-table-column label="题目" width="300px" align="center" show-overflow-tooltip="">
                            <template slot-scope="scope">
                                <div style="text-overflow:ellipaos" v-html="scope.row.title"></div>
                            </template>
                        </el-table-column>

                        <el-table-column prop="category_name" align="center" label="题型" width="">
                        </el-table-column>

                        <el-table-column  label="对错" align="center" >
                            <template slot-scope="scope">
                                <i :class="[scope.row.user_is_right == 'Y' ? 'el-icon-check el-icon-check-color' : 'el-icon-close el-icon-close-color' ]"></i>
                            </template>
                        </el-table-column>

                        <el-table-column prop="user_get_score" align="center" label="得分">
                        </el-table-column>

                        <el-table-column  label="操作" align="center" >
                            <template slot-scope="scope">
                                  <el-button size="small" type="primary" @click="viewReportDetail(scope)">详情</el-button>
                            </template>
                        </el-table-column>

                    </el-table>
                </template>
            </el-tab-pane>
            <el-tab-pane label="知识点" name="second">
                <template>
                    <el-table :data="knowledge_data" stripe style="width: 100%">
                        <el-table-column
                        type="index"
                        width="50"
                        abel="序号">
                        </el-table-column>

                        <el-table-column  label="知识点" align="center" >
                            <template slot-scope="scope">
                                <div style="color:#409EFF;">{{scope.row.detail_name}}</div>
                            </template>
                        </el-table-column>

                        <el-table-column prop="total_error_count" align="center" label="错题数" width="">
                        </el-table-column>

                        <el-table-column prop="total_count" align="center" label="总题数" width="">
                        </el-table-column>

                        <el-table-column prop="loss_rate" align="center" label="失分率" width="">
                        </el-table-column>

                        <el-table-column  label="操作" align="center" >
                            <template slot-scope="scope">
                                  <el-button size="small" type="primary" @click="showDetailSource(scope.row)">去学习</el-button>
                            </template>
                        </el-table-column>

                    </el-table>
                </template>
            </el-tab-pane>
        </el-tabs>

        <div>
            <span v-loading.fullscreen.lock="fullScreenLoading">
                <el-dialog
                :visible.sync="dialogVisible"
                :before-close="handleClose"
                :append-to-body="true"
                title="题目详情"
                width="60%"
                top="8vh"
                >
                <el-row v-for="(item, index) in dialogShowData" :key="index" class="question-box">
                    <div >
                        <el-col :span="4">
                            <div class="question-index">
                                <span>{{item.q_index  + 1}} </span>、 <span class="category-name">（{{item.category_name}}） </span>
                            </div>
                        </el-col>
                        <el-col :span="20">
                            <div class="" v-html="item.title">
                            </div>
                        </el-col>
                        <el-col  :span="24" v-if="item.audio_resources_url != ''" class="question-source">
                            <audio controls height="100" width="100">
                                <source :src="source_prefix+item.audio_resources_url" type="audio/mpeg">
                            </audio>
                        </el-col>

                        <div v-if="item.category_id != 5 && item.category_id != 6">
                            <div>
                                <el-col :span="24" class="option-box">
                                    <div  v-for="(o_item, o_index) in item.option_data" :key="o_index" class="option-item">
                                        <div>
                                            <span style="padding-left:20px">
                                                {{String.fromCharCode(65 + o_index)}}  | 
                                            </span>
                                            <span style="padding-left:10px">
                                                {{o_item.content}}
                                            </span>
                                        </div>
                                    </div>
                                </el-col>

                                <el-col :span="24" class="right-answer">
                                    <div>
                                        <span class="lable-title">正确答案：</span>
                                        <span v-for="(r_item, r_index) in item.right_option_data" :key="r_index" class="option-font">
                                            <span v-for="(o_item, o_index) in item.option_data" :key="o_index">
                                                <span v-if="r_item.option_guid == o_item.option_guid">
                                                    {{String.fromCharCode(65 + o_index)}}
                                                </span>
                                            </span>
                                        </span>
                                    </div>
                                </el-col>
                                
                                <el-col :span="24" class="user-answer">
                                    <div>
                                        <span class="lable-title">您的答案：</span>
                                        <span v-if="item.user_answer_data.length != 0" :class="[item.user_is_right == 'Y' ? 'el-icon-check-color' : 'el-icon-close-color' ]">
                                            <span v-for="(u_item, u_index) in item.user_answer_data" :key="u_index">
                                                <span v-for="(o_item, o_index) in item.option_data" :key="o_index">
                                                    <span v-if="u_item.option_guid == o_item.option_guid">
                                                        {{String.fromCharCode(65 + o_index)}}
                                                    </span>
                                                </span>
                                            </span>
                                        </span>
                                        <span v-else>未做答</span>
                                        <span>
                                            <i :class="[item.user_is_right == 'Y' ? 'el-icon-check el-icon-check-color' : 'el-icon-close el-icon-close-color' ]"></i>
                                        </span>
                            
                                    </div>
                                </el-col>
                            </div>
                        </div>
                        <div v-else>
                            <div v-for=" s_item, s_index in item.son_question_data" :key="s_index" >
                                <el-row class="">
                                    <el-col :span="2">
                                        <div class="question-index">
                                            (<span>{{s_index + 1}} </span>)
                                        </div>
                                    </el-col>
                                    <el-col :span="22">
                                        <div class="" v-html="s_item.title">
                                        </div>
                                    </el-col>
                                </el-row>
   
                                <el-col :span="24" class="option-box">
                                    <div  v-for="(s_o_item, s_o_index) in s_item.option_data" :key="s_o_index" class="option-item">
                                        <div>
                                            <span style="padding-left:20px">
                                                {{String.fromCharCode(65 + s_o_index)}}  | 
                                            </span>
                                            <span style="padding-left:10px">
                                                {{s_o_item.content}}
                                            </span>
                                        </div>
                                    </div>
                                </el-col>

                                <el-col :span="24" class="right-answer">
                                    <div>
                                        <span class="lable-title">正确答案：</span>
                                        <span v-for="(r_item, r_index) in s_item.right_option_data" :key="r_index" class="option-font">
                                            <span v-for="(o_item, o_index) in s_item.option_data" :key="o_index">
                                                <span v-if="r_item.option_guid == o_item.option_guid">
                                                    {{String.fromCharCode(65 + o_index)}}
                                                </span>
                                            </span>
                                        </span>
                                    </div>
                                </el-col>
                                
                                <el-col :span="24" class="user-answer">
                                    <div>
                                        <span class="lable-title">您的答案：</span>
                                        <span v-if="s_item.user_answer_data.length != 0" :class="[s_item.user_is_right == 'Y' ? 'el-icon-check-color' : 'el-icon-close-color' ]">
                                            <span v-for="(u_item, u_index) in s_item.user_answer_data" :key="u_index">
                                                <span v-for="(o_item, o_index) in s_item.option_data" :key="o_index">
                                                    <span v-if="u_item.option_guid == o_item.option_guid">
                                                        {{String.fromCharCode(65 + o_index)}}
                                                    </span>
                                                </span>
                                            </span>
                                        </span>
                                        <span v-else>未做答</span>
                                        <span>
                                            <i :class="[s_item.user_is_right == 'Y' ? 'el-icon-check el-icon-check-color' : 'el-icon-close el-icon-close-color' ]"></i>
                                        </span>
                            
                                    </div>
                                </el-col>
                            </div>
                        </div>

                        <el-col :span="24" class="answer-detail" v-if="item.answer_detail != ''">
                            <div>
                                <div class="detail-lable">
                                     <span class="lable-title">解析：</span>
                                </div>
                                <div v-html="item.answer_detail"></div>
                            </div>
                        </el-col>
                    </div>
                </el-row>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleClose">取 消</el-button>
                </span>
                </el-dialog>
            </span>
        </div>

    </div>

</template>
<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
    setup() {

    },
})
</script>


<script>
    import { userHomeworkReport, specialVideoList} from '../api'
    import store from '@/store'
    import VideoShow from '@/components/videoShow'
    export default {
        name: 'Viewreport',
        props: ['cate', 'words'],
        provide() {
            return {
            app: this
            }
        },
        data() {
            return {
                dialogShowData:[],
                dialogVisible: false,
                fullScreenLoading: false,
                activeName: 'first',
                form:{
                    work_guid:"",
                    class_guid:"",
                    uid:""
                },
                base_data:{},
                statistical_data:{},
                question_map:[],
                knowledge_data:[],
                source_prefix:process.env.VUE_APP_UPYUN_PATH,
            }
        },
        components: {
            VideoShow
        },
        computed: {
        },
        methods: {
            handleClick(tab, event) {

            },
            userHomeworkReportFun()
            {
                userHomeworkReport(this.form).then(response => {
                    this.base_data = response.base_data
                    this.statistical_data = response.statistical_data
                    if(this.base_data.work_category_id == 5)
                    {
                        this.question_map = response.word_map
                    }
                    else
                    {
                        this.question_map = response.question_map
                    }

                    this.knowledge_data = response.knowledge_data

                })
            },
            viewReportDetail(data)
            {
                var retRow = data.row
                retRow.q_index = data.$index
               
                this.dialogShowData = [];
                this.dialogShowData.push(retRow);
                this.dialogVisible = true;
            },
            handleClose(){
                this.dialogVisible = false;
            },
            viewReportAll()
            {
                var retAll = [];
                for(const i in this.question_map)
                {
                    var retRow = this.question_map[i]
                    //题目序号
                    retRow.q_index =  parseInt(i)
                    retAll.push(retRow)
                }
                this.dialogShowData = retAll
                this.dialogVisible = true;

            },
            showDetailSource(e)
            {

                var form = {
                    detail_guid : e.detail_guid,
                    is_vip_user : 1
                }

                specialVideoList(form).then(response => {

                    if(response.length != 0)
                    {
                        this.$refs.VideoShow.show(response[0].sources_url)
                    }
                })


            }

   
        },
        mounted() {
            this.form.work_guid = this.$route.query.work_guid
            this.form.uid = store.state.user.guid
            this.userHomeworkReportFun()
        }
    }
</script>
<style scoped lang="less">
    .report-box{
        margin:8vh 10vw 0 10vw
    }
    .report-title{
        text-align: center;
        font-size: 24px;
        margin:10px 0 20px 0;
    }
    .option-item{
        min-height: 3.5vh;
        line-height:3.5vh;
        margin-top:2vh;
        border: 1px solid;
        width: 20vw;
        background: #fff;
        border: 1px solid #dcdfe6;
        cursor: pointer;
    }
     .question-index{
        text-align: right;
    }
     .option-box{
        margin-top:0vh;
        margin-left: 3vw;
    }
    .view-report-all-btn{
        text-align: right;
        margin-right: 5vw;
    }
    .question-source{
        margin-top:1vh;
        padding-left:3vw;
    }
    .question-box{
        margin-bottom: 3vh;
        padding: 2vh;
        border-bottom: 1px solid #909399
    }
    .user-answer{
        padding: 1vh 0 1vh 2vw;
    }
    .right-answer{
        padding: 1vh 0 1vh 2vw;
    }
    .answer-detail{
        padding: 1vh 0 1vh 2vw;
    }
    .detail-lable{
        padding-bottom:10px;
    }

    .el-icon-check-color{
        color:#67C23A;
        font-size: 18px
    }

    .el-icon-close-color{
        color:#F56C6C;
        font-size: 18px
    }

    .option-font{
        font-size:18px;
    }
    .category-name{
        color:#409EFF;
    }
    .lable-title{
        color:#409EFF
    }
    .son-box{
        margin-top:30px;
    }
</style>
